import React, {useEffect, useState} from "react";
import "../../sass/main.scss";
import CmnCard from "../CmnCard";
import $ from "jquery";
import axios2 from "../../helpers/APIHelper";
import Fn from "../../libraries/Fn";


const ConfigJoinRoute = (props) => {
	
  window._load = (_page = 1) => {
    try {
      load(_page);
    } catch (e) {
    }
  }

  const [rets, setRets] = useState([]);
  const [renew, setRenew] = useState(0);

  useEffect(() => {
    $('#base_seq').val('');
    $('#sub_code').val('');
    $('#sub_code_name').val('');
    $('#show_YN').val('Y');
    $('#show_out').val('');
    $('#sub_code2').css('backgroundColor', '#ffffff');
    $('#sub_code').attr('readOnly', false);
    $('#sub_code_name').focus();

    load();
  }, [renew]);

  const load = () => {
    axios2
      .post(`/config/join/route/ready`)
      .then((response) => {
        const {code, message, result, pageInfo} = response?.data;
        if (code === 200) {
          setRets(result?.list);
        }
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      });
  }

  //  2-1.
  const go_submit = () => {
    // const regBtn = $('.reg-btn');
    // regBtn.html("<a class='btn btn-danger btn-sm'><span class='glyphicon glyphicon-saved'></span> 저장</a>");

    if ($('#sub_code').val() === '') {
      alert('코드를 입력해주세요');
      $('#sub_code').focus();
      // regBtn.html("<a class='btn btn-danger btn-sm' onclick='go_submit()'><span class='glyphicon glyphicon-saved'></span> 저장</a>");
      return;
    }

    if ($('#sub_code_name').val() === '') {
      alert('가입경로를 입력해주세요');
      $('#sub_code_name').focus();
      // regBtn.html("<a class='btn btn-danger btn-sm' onclick='go_submit()'><span class='glyphicon glyphicon-saved'></span> 저장</a>");
      return;
    }

    axios2
      .postEx('/employee/em/config', {
        base_seq: $('#base_seq').val(),
        sub_code: $('#sub_code').val(),
        sub_code_name: $('#sub_code_name').val(),
        show_YN: $('#show_YN option:selected').val(),
        show_out: $('#show_out').val(),
        main_code_fk: "2"
      })
      .then((response) => response.json())
      .then(({code, message: data, result, pageInfo}) => {
        if (data == "err") {
          alert('오류가 발생하였습니다');
        } else if (data == "dup_id") {
          alert('동일한 코드가 존재합니다')
          // reg_btn.innerHTML = "<a class='btn btn-danger btn-sm'  onclick='go_submit()'><span class='glyphicon glyphicon-saved'></span> 저장</a>";
        } else if (data == "dup_name") {
          alert('동일한 가입경로명이 존재합니다')
          // reg_btn.innerHTML = "<a class='btn btn-danger btn-sm'  onclick='go_submit()'><span class='glyphicon glyphicon-saved'></span> 저장</a>";
        } else if (data == "in_ok") {
          alert("등록되었습니다");
          setRenew(Fn.getRenewTime());
        } else if (data == "up_ok") {
          alert("수정되었습니다");
          setRenew(Fn.getRenewTime());
        } else if (data == "del_ok") {
          alert("삭제되었습니다");
          setRenew(Fn.getRenewTime());
        } else if (data == "in_err") {
          alert("등록오류! 관리자에게 문의하세요");
          // setRenew(Fn.getRenewTime());
        } else if (data == "up_err") {
          alert("수정오류! 관리자에게 문의하세요");
          // setRenew(Fn.getRenewTime());
        }
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      });
  };

  const copy_data = (baseSeq, subCode, subCodeName, showYN, showOut) => {
    $('#base_seq').val(baseSeq);
    $('#sub_code').val(subCode);
    $('#sub_code_name').val(subCodeName);
    $('#show_YN').val(showYN);
    $('#show_out').val(showOut);

    $('#sub_code2').css('backgroundColor', '#fee9ec');
    $('#sub_code').attr('readOnly', true);

    $('#sub_code_name').focus();
  };

  const del_data = (base_seq) => {
    if (!window.confirm('해당 방문경로를 삭제하시겠습니까?')) return;

    axios2
      .postEx('/employee/em/config', {
        type: 'del',
        base_seq: base_seq,
      })
      .then((response) => response.json())
      .then(({code, message: data, result, pageInfo}) => {
        alert("삭제되었습니다");
        setRenew(Fn.getRenewTime());
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      });
  };

  return (
    <CmnCard onLogout={props.onLogout}>
      <div className="m-3 search_box" style={{maxWidth: "935px"}}>
        {/* 회원검색 */}
        <div className="p-3">
          <input type="hidden" id="base_seq" value=""/>
          <table className="view-rounded sub_view">
            <colgroup>
              <col width="108px"/>
              <col width="*"/>
              <col width="108px"/>
              <col width="*"/>
              <col width="108px"/>
              <col width="70px"/>
              <col width="108px"/>
              <col width="100px"/>
            </colgroup>
            <tr>
              <th>코드</th>
              <td><input type="text" className="form-control" aria-describedby="button-addon2" id="sub_code"/></td>
              <th>방문경로</th>
              <td><input type="text" className="form-control" aria-describedby="button-addon2" id="sub_code_name"/></td>
              <th>전시순서</th>
              <td><input type="text" className="form-control" aria-describedby="button-addon2" id="show_out"/></td>
              <th>전시여부</th>
              <td>
                <select className="form-select" aria-label="Default select example" id="show_YN">
                  <option value="Y">전시</option>
                  <option value="N">미전시</option>
                </select>
              </td>
            </tr>
          </table>
          <div className="text-center mt-2">
            <button type="button" className="btn btn-sm btn-point px-3" onClick={() => go_submit()}>저장</button>
          </div>
        </div>
      </div>

      <div className="m-3 pb-2 table_list" style={{maxWidth: "935px"}}>
        <table className="view-rounded sub_table_border">
          <colgroup>
            <col width="60px"/>
            <col width="*"/>
            <col width="35%"/>
            <col width="*"/>
            <col width="*"/>
            <col width="*"/>
          </colgroup>
          <tr>
            <th>No</th>
            <th>코드</th>
            <th>방문경로</th>
            <th>전시여부</th>
            <th>전시순서</th>
            <th>비고</th>
          </tr>
          {rets && rets.map((ret, i) => {

            const showYN = ret?.show_YN;
            const showYNText = showYN === 'Y' ? <span className="text-success">전시</span> : <span className="text-danger">미전시</span>;

            return (
              <tr>
                <td>{i + 1}</td>
                <td>{ret?.sub_code}</td>
                <td className="text-left">{ret?.sub_code_name}</td>
                <td>{showYNText}</td>
                <td>{ret?.show_out}</td>
                <td>
                  <button type="button" className="btn btn-ssm btn-dark"
                          onClick={() =>
                            copy_data(
                              btoa(ret?.seq),
                              ret?.sub_code,
                              ret?.sub_code_name,
                              ret?.show_YN,
                              ret?.show_out
                            )
                          }
                  >수정
                  </button>
                  <button type="button" className="btn btn-ssm btn-gray mx-1" onClick={() => del_data(btoa(ret?.seq))}>삭제</button>
                </td>
              </tr>
            );
          })}
          {(!rets || rets?.length === 0) &&
            <tr>
              <td colSpan={4}>※ 등록된 data가 없습니다.</td>
            </tr>
          }
        </table>
      </div>
    </CmnCard>
  );
};

export default ConfigJoinRoute;
